import { DangerButton } from '@/components/Buttons';
import { MotiView, Row, ThemeText, View } from '@/components/Theme';
import colors from '@/constants/Colors';
import { elements } from '@/constants/Styles';
import { useCurrentUrl } from '@/hooks/useCurrentUrl';
import { useRouter } from 'expo-router';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { ResponseIcon } from './ResponseIcon';

export const ErrorView = memo((props) => {
    const { 
        title = 'Fehler', 
        subline, 
        icon = 'alert-circle',
        action = true,
        contentContainerStyle = null, 
        hideTitle = false, 
        spinnerSize = '2xl', 
        innerPadding = 12,
        error = null,
        children = null,
        titleProps = {},
        sublineProps = {},
    } = props;

    const router = useRouter();
    const {fullPath, params} = useCurrentUrl({splitParams: false});

    const onPressContact = () => {
        let errorText = null;
        
        if (typeof error === 'string') {
            errorText = ` (Fehlercode: ${error})`;  
        }
        
        return router.push('/contact?subject=error_reporting&from=' + `${fullPath}?${params}`);
    }

    return (
        
        <View style={[styles.container, {width: '100%', height: '100%'}, contentContainerStyle]}>    
            <MotiView style={elements.center} from={{scale: .8, opacity: 0}} animate={{scale: 1, opacity: 1}}>
                <ResponseIcon 
                    icon={'triangle-warning'}
                    innerPadding={innerPadding}
                    colorScheme={'red'}
                />
                
                {hideTitle != true && 
                    <>
                        <ThemeText mt={25} variant={'h1,center'} color={'red.600'} id={title} {...titleProps} />
                        <ThemeText mt={15} variant={'p,center'} id={subline ?? 'messages.error.description'} {...sublineProps} />
                        
                        {error?.length > 3 && <ThemeText variant={'p,center'}>ErrorCode: {error}</ThemeText>}

                        {action && 
                            <>
                                <View h={5} />
                                
                                <Row gap={12} style={[elements.center, {marginTop: 20, flexWrap: 'wrap'}]}>
                                    {children}
                                    <DangerButton 
                                        title={'buttons.contactform'} 
                                        onPress={onPressContact} 
                                        size={'sm'}
                                    />
                                </Row>
                            </>
                        }
                    </>
                }
            </MotiView>
        </View>
    );
}, isEqual);

const styles = StyleSheet.create({
    container: {
        ...elements.center,
        flexDirection: 'column',
        ...StyleSheet.absoluteFillObject,
        zIndex: 1000,
        paddingHorizontal: 25,
    },
    spinnerWrapper: {
        ...elements.center,
        backgroundColor: colors.red[100],
        borderRadius: 250
    },
});
